// extracted by mini-css-extract-plugin
export default {"airportLabel":"gn43EI"};